import React from "react";
import { StepContent, InfoBanner, InfoBannerIcon } from "../styles";
import FilterConfigEditor from "../FilterConfigEditor";
import type { FilterConfig } from "../../../store/api/dataSourcesApi";

interface StepQueryFiltersProps {
  value: FilterConfig;
  onChange: (next: FilterConfig) => void;
  fieldOptions?: string[];
}

const StepQueryFilters: React.FC<StepQueryFiltersProps> = ({
  value,
  onChange,
  fieldOptions,
}) => {
  return (
    <StepContent>
      <InfoBanner>
        <InfoBannerIcon>{"\u26A0"}</InfoBannerIcon>
        Query filters scope every agent search. Use this for multi-tenant
        indexes (for example mapping consumer organisation to an Algolia
        facet). You can skip this step if the index is already single-tenant.
      </InfoBanner>
      <FilterConfigEditor
        value={value}
        onChange={onChange}
        fieldOptions={fieldOptions}
      />
    </StepContent>
  );
};

export default StepQueryFilters;
